import React from 'react';
import { Footer } from '../components/common/Footer/Footer';
import { Outlet } from 'react-router-dom';
import { Navbar } from '../components/common/NavBar/Navbar';
import './privateLayOut.css'
import { SideMenu } from '../components/common/SideMenu/SideMenu';
import { ResponsiveNav } from '../components/common/ResponsiveNavBar/ResponsiveNav';


export const PrivateLayout = () => {
  return (


    <div className='Div-Principal'>

      <div className="row row-class">

        <SideMenu />



        <div className='col-12 col-md-10 cont-secundario'>
          <Navbar />



          <Outlet /> {/* Renderiza las rutas hijas */}


          <ResponsiveNav />
          {/* <Footer /> */}
        </div>



      </div>
    </div>


  );
};
